import React, { lazy } from 'react'

import { LayoutType } from 'Portals/Supplier/constants/layout'

import { Props } from './types'

const NotFoundPage = lazy(() => import('Shared/organisms/NotFound'))
const General = lazy(() => import('Portals/Supplier/Layouts/General'))
const RegistrationDocument = lazy(() => import('Portals/Supplier/Layouts/RegistrationDocument'))

const Layouts: React.FC<Props> = ({ layoutType }) => {
	const renderComponent = () => {
		switch (layoutType) {
			case LayoutType.general:
				return <General />
			case LayoutType.registrationDocument:
				return <RegistrationDocument />
			default:
				return <NotFoundPage />
		}
	}
	return renderComponent()
}

export default React.memo(Layouts)
